import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api_url from "../../libary/axios-home";

export const initialState = {
  faqList: [],
};

export const fetchCompanyFaqApi = createAsyncThunk(
  "getCompanyFaq/fetchCompanyFaq",
  async ({ id }) => {
    try {
      const response = await api_url.get("faq/admin/" + id);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
);

const getCompanyFaqSlice = createSlice({
  name: "getCompanyFaq",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchCompanyFaqApi.pending, (state, action) => {
      // Add user to the state array
      state.status = "loading";
    });
    builder.addCase(fetchCompanyFaqApi.fulfilled, (state, action) => {
      // Add user to the state array
      state.status = "succeded";
      state.faqList = action.payload;
    });
    builder.addCase(fetchCompanyFaqApi.rejected, (state, action) => {
      // Add user to the state array
    });
  },
});

export default getCompanyFaqSlice.reducer;
